export default {
  pharmacyName: "Chemist Warehouse",
  pharmacyAddress1: "Reply Paid 612",
  pharmacyAddress3: "VIRGINIA QLD 4014",
  pharmacyEmail: "instantconsult@chemistwarehouse.com.au",
  pharmacyNumber: "07 3135 6295"
};
